import angular from 'angular';
import uiRouter from 'angular-ui-router';
import newsComponent from './news.component';
import mainNewsItem from './mainNewsItem/mainNewsItem';

let newsModule = angular.module('news', [uiRouter, mainNewsItem])
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider
      .state('news', {
        url: '/news',
        component: 'news',
        resolve: {
          $title: () => 'News'
        }
      });
  })
  .component('news', newsComponent)
  .name;

export default newsModule;



// WEBPACK FOOTER //
// ./client/app/components/news/news.js